// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-qWev","colBig":"styles_colBig__117jk","colSmall":"styles_colSmall__NICyi","shopifyNameWrapper":"styles_shopifyNameWrapper__1Eq8r"};